<template>
  <div class="estimate-detail" v-if="currentTab && hideStatus">
    <LableContent
      :label="detailConfig.detailLabel"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      height="450px"
      bottomPadding="0px"
    >
      <TabBtn
        ref="tabBtnRef"
        :tabs="tabsFilter"
        :active-tab="tabActive"
        height="100%"
        @tab-click="initData"
      >
        <template slot="btn">
          <el-button type="primary" size="mini" @click="handleDrEstimate">
            {{ detailConfig.drButtonText }}
          </el-button>
          <el-button type="primary" size="mini" @click="handleGlobalEstimate">
            {{ detailConfig.globalButtonText }}
          </el-button>
        </template>
        <template>
          <SimpleTable
            ref="topTable"
            :menus="menus"
            height="50%"
            :columns="columns.top"
            :data="tableData.top"
            table-code="EstimateDetailTop"
            :loading="loading.top"
            @row-select="onRowSelectTop"
            @modify-data-change="onModifyDataChangeTop"
          />
        </template>
      </TabBtn>
    </LableContent>

    <LableContent
      v-if="showHistory"
      label="历史数据"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      :height="detailConfig.showHistoryTabs ? '350px' : '450px'"
      bottomPadding="0px"
      style="width: 100%"
    >
      <TabBtn
        v-if="detailConfig.showHistoryTabs"
        ref="tabBtnRefHistory"
        :tabs="detailConfig.tabsHistory"
        :active-tab="tabHistoryActive"
        height="100%"
        @tab-click="initDataHistory"
      >
        <SimpleTable
          v-if="isHistoryProjectTab"
          ref="bottomTable"
          height="50%"
          :menus="['查询', '插入', '批量删除', '批量修改']"
          :menusMergeAfter="menusMergeAfterBottom"
          :columns="columns.bottom"
          :data="tableData.bottom"
          table-code="EstimateDetailBottom"
          :loading="loading.bottom"
          :bottomFrozenRowCount="1"
          @row-select="onRowSelectBottom"
          @modify-data-change="onModifyDataChangeBottom"
        />

        <div v-if="isProjectOverviewTab" class="project-overview-box">
          <SimpleTable
            :allowMultiSelect="false"
            ref="tableLeft"
            :loading="loadingLeft"
            :columns="columnsLeft"
            :data="tableDataLeft"
            @row-select="handleRowSelectLeft"
          />
          <SimpleTable
            :allowMultiSelect="false"
            :show-index="false"
            ref="tableCenter"
            :loading="loadingCenter"
            :columns="columnsCenter"
            :data="tableDataCenter"
            @modify-data-change="handleModifyDataChangeCenter"
          />
          <SimpleTable
            :show-index="false"
            ref="tableRight"
            :loading="loadingRight"
            :columns="columnsRight"
            :data="tableDataRight"
            @modify-data-change="handleModifyDataChangeRight"
          />
        </div>
      </TabBtn>

      <SimpleTable
        v-else
        ref="bottomTable"
        :menus="['查询', '插入', '批量删除', '批量修改']"
        :menusMergeAfter="menusMergeAfterBottom"
        :columns="columns.bottom"
        :data="tableData.bottom"
        table-code="EstimateDetailBottom"
        :loading="loading.bottom"
        :bottomFrozenRowCount="1"
        @row-select="onRowSelectBottom"
        @modify-data-change="onModifyDataChangeBottom"
      />
    </LableContent>

    <LableContent
      v-if="showCostIndicatorContent"
      :label="detailConfig.costIndicatorLabel"
      hasCollapse
      showFullScreen
      style="width: 100%"
      height="350px"
      bottomPadding="10px"
    >
      <SimpleTable
        ref="bottomZb"
        style="height: 100%"
        height="50%"
        :menus="['查询', '批量删除', '批量修改']"
        :columns="columns.bottomZb"
        :data="tableData.bottomZb"
        table-code="EstimateDetailBottomZb"
        :loading="loading.bottomZb"
        :bottomFrozenRowCount="1"
        @modify-data-change="onModifyDataChangeBottomZb"
      />
    </LableContent>

    <LableContent
      :label="detailConfig.dynamicLabel"
      class="gusuan-detail"
      hasCollapse
      showFullScreen
      :height="detailConfig.dynamicHeight"
      topPadding="0px"
      bottomPadding="10px"
    >
      <div class="left-right-box1" style="height: 100%">
        <SimpleTable
          width="70%"
          ref="leftTable"
          :columns="columns.left"
          :data="tableData.left"
          table-code="EstimateDetailLeft"
          :loading="loading.left"
        />
        <SimpleTable
          width="calc(30% - 11px)"
          ref="rightTable"
          :menus="['查询', '上传', '批量删除']"
          :columns="columns.right"
          :data="tableData.right"
          table-code="EstimateDetailRight"
          :loading="loading.right"
          :uploadParams="uploadParams"
          @cell-dblclick="handleCellDblclickRight"
        />
      </div>
    </LableContent>

    <SelectBaseAmountDialog
      ref="SelectBaseAmountDialog"
      :tabs="tabsFilter"
      @confirm="handleSelectBaseAmountDialogConfirm"
    />
    <HistoryProjectDialog
      v-if="detailConfig.hasHistory"
      ref="HistoryProjectDialog"
      @confirm="handleInsertHistoryConfirm"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import LableContent from '@/components/LableContent/index.vue'
import SelectBaseAmountDialog from './SelectBaseAmountDialog.vue'
import HistoryProjectDialog from './HistoryProjectDialog.vue'
import { sortRecords, addCbFn, preViewFile } from '@/utils/index'
import { createEstimateDetailConfig } from './config'

const PROJECT_TYPE_EXCLUDED_TABS = {
  业主项目: ['constructionIncome', 'chargingIncome'],
  BOT项目: [
    'landCost',
    'saleCost',
    'constructionIncome',
    'chargingIncome',
    'saleIncome'
  ],
  BOO项目: ['saleCost', 'constructionIncome', 'chargingIncome', 'saleIncome'],
  EPC项目: ['landCost', 'saleCost', 'opsCost', 'saleIncome', 'opsIncome'],
  施工总包项目: [
    'landCost',
    'chargingItems',
    'saleCost',
    'opsCost',
    'saleIncome',
    'chargingIncome',
    'opsIncome'
  ]
}

export default {
  name: 'CommonEstimateDetail',
  components: {
    SimpleTable,
    TabBtn,
    LableContent,
    SelectBaseAmountDialog,
    HistoryProjectDialog
  },
  inject: ['detailsVm'],
  props: {
    basicInfo: {
      type: Object,
      default: () => ({})
    },
    historyInsertType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tabActive: null,
      currentTab: null,
      columns: { top: [], bottom: [], bottomZb: [], left: [], right: [] },
      tableData: { top: [], bottom: [], bottomZb: [], left: [], right: [] },
      tabHistoryActive: null,
      currentTabHistory: {},
      loading: {
        top: false,
        bottom: false,
        bottomZb: false,
        left: false,
        right: false
      },
      currentSelect: {
        top: null,
        bottom: null,
        bottomZb: null,
        left: null,
        right: null
      },
      uploadParams: {
        id: '',
        accept: '',
        uploadAfter: () => this.uploadAfter()
      },
      columnsLeft: [{ field: 'name', title: '工程分类', widht: 100 }],
      columnsCenter: [
        { field: 'name', title: '工程特征', widht: 100 },
        {
          field: 'featureValue',
          title: '特征值',
          width: 200,
          canModify: true,
          editModal: {
            columns: [{ field: 'name', title: '工程特征', tree: true }],
            allowMultiSelect: true,
            options: () => this.getEngineeringFeatureOptions(),
            confirm: (selectedCellInfos, res) => {
              const arr = res.map(e => e[0].originData.name)
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'featureValue', arr.join(' '))
              })
            }
          }
        }
      ],
      columnsRight: [
        { field: 'name', title: '工程参数', widht: 100 },
        {
          field: 'paramValue',
          title: '参数值',
          width: 200,
          fieldType: 'number',
          canEdit: true,
          canModify: true
        }
      ],
      tableDataLeft: [],
      tableDataCenter: [],
      tableDataRight: [],
      loadingLeft: false,
      loadingCenter: false,
      loadingRight: false
    }
  },
  computed: {
    detailConfig() {
      return createEstimateDetailConfig(this.historyInsertType)
    },
    hideStatus() {
      if (this.basicInfo.projectType === '施工总包项目') {
        return this.historyInsertType === 'bill'
      }
      return true
    },
    tabsFilter() {
      const { projectType } = this.basicInfo
      let excluded
      if (projectType === 'EPCO项目') {
        excluded =
          this.historyInsertType === 'bill'
            ? ['landCost', 'saleIncome', 'saleCost']
            : ['landCost', 'saleIncome', 'chargingIncome', 'saleCost']
      } else {
        excluded = PROJECT_TYPE_EXCLUDED_TABS[projectType] || []
      }
      return this.detailConfig.tabs.filter(tab => !excluded.includes(tab.key))
    },
    globalEstimateParams() {
      const key = this.detailConfig.globalEstimateParamKey
      return key ? { [key]: this.basicInfo.id } : {}
    },
    menus() {
      if (!this.currentTab) return ['查询']
      const { readOnlyTabValues, projectUnitTabValue } = this.detailConfig
      if (readOnlyTabValues.includes(this.currentTab.value)) {
        return ['查询']
      }
      if (this.currentTab.value === projectUnitTabValue) {
        return ['查询', '插入', '批量修改', '批量删除']
      }
      return ['查询', '插入', '批量修改', '批量删除', '选中模板', '保存模板']
    },
    showHistory() {
      const { hasHistory, projectUnitTabValue } = this.detailConfig
      return (
        hasHistory &&
        (this.currentTab?.value === projectUnitTabValue ||
          this.currentTab?.value === 'common-construction-income')
      )
    },
    isHistoryProjectTab() {
      return (
        !this.detailConfig.showHistoryTabs ||
        this.currentTabHistory?.value ===
          this.detailConfig.historyProjectTabValue
      )
    },
    isProjectOverviewTab() {
      return (
        this.currentTabHistory?.value ===
        this.detailConfig.projectOverviewTabValue
      )
    },
    showCostIndicatorContent() {
      return (
        this.detailConfig.showCostIndicator &&
        this.showHistory &&
        this.isHistoryProjectTab
      )
    }
  },
  created() {},
  methods: {
    init() {
      const { tabsHistory, baseAmountTabValues } = this.detailConfig
      this.tabActive = this.tabsFilter[0]?.value
      this.tabHistoryActive = tabsHistory[0]?.value
      this.currentTabHistory = tabsHistory[0] || {}
      if (this.$refs.tabBtnRef) this.$refs.tabBtnRef.active = this.tabActive
      baseAmountTabValues.forEach(value => {
        const element = this.tabsFilter.find(tab => tab.value === value)
        const obj = element?.columns?.top?.find(e => e.field === 'baseAmount')
        if (obj) obj.handleEdit = this.handleEditBillBaseAmount
      })
      this.initData(this.tabsFilter[0])
    },

    initData(currentTab) {
      if (!currentTab) return
      this.currentTab = currentTab
      this.tabActive = currentTab.value
      this.columns.top = currentTab.columns.top
      this.columns.bottom = currentTab.columns.bottom || []
      this.columns.bottomZb = currentTab.columns.bottomZb || []
      this.columns.left = currentTab.columns.left
      this.columns.right = currentTab.columns.right

      this.getTable({ type: 'top', code: this.getTabCode(currentTab) })
    },

    getTabCode(tab) {
      return tab[this.detailConfig.requestField]
    },

    formatApiPath(code) {
      return code?.startsWith('/') ? code : `/${code}`
    },

    async getTable({ type, code, isLocal = true }) {
      this.tableData[type] = []
      this.tableData.bottom = []
      this.tableData.bottomZb = []
      this.tableData.left = []
      this.tableData.right = []
      this.loading[type] = true
      const params = { mainId: this.basicInfo.id }
      if (this.currentTab.queryType) {
        params.type = this.currentTab.queryType
      }
      const apiPath = this.currentTab.apiCode || this.formatApiPath(code)
      const res = await this.$service.get(`${apiPath}/list`, params)
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
      const tableRef = this.$refs[type + 'Table']
      if (res?.data?.length && isLocal && tableRef) tableRef.initialized()
    },

    async getBottomTable({ type = 'bottom', isLocal = true } = {}) {
      const { budgetHistoryUrl } = this.detailConfig
      if (!this.showHistory || !this.isHistoryProjectTab || !budgetHistoryUrl) {
        return
      }
      this.tableData[type] = []
      this.tableData.bottomZb = []
      this.loading[type] = true
      const res = await this.$service.get(`${budgetHistoryUrl}/list`, {
        itemId: this.currentSelect.top?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
      const tableRef = this.$refs[type + 'Table']
      if (res?.data?.length && isLocal && tableRef) tableRef.initialized()
    },

    async getLeftTable(type = 'left') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const params = { itemId: this.currentSelect.top?.id }
      const mainKey = this.detailConfig.timeDistributionMainKey
      if (mainKey) params[mainKey] = this.basicInfo.id
      const res = await this.$service.get(
        '/common-time-distribution/list',
        params
      )
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    async getRightTable(type = 'right') {
      this.tableData[type] = []
      if (!this.currentSelect.top?.id) return
      this.loading[type] = true
      const params = { projectUnitId: this.currentSelect.top?.id }
      Object.entries(this.detailConfig.fileListBasicFieldParams).forEach(
        ([key, field]) => {
          params[key] = this.basicInfo[field]
        }
      )
      const res = await this.$service.get(
        `/business-file/list/${this.currentSelect.top?.id}`,
        params
      )
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    async getbottomZbTable(type = 'bottomZb') {
      const { costIndicatorUrl } = this.detailConfig
      if (!costIndicatorUrl) return
      this.tableData[type] = []
      this.loading[type] = true
      const res = await this.$service.get(`${costIndicatorUrl}/list`, {
        itemId: this.currentSelect.bottom?.id
      })
      this.loading[type] = false
      this.tableData[type] = sortRecords(res?.data || [])
    },

    onRowSelectTop(rows) {
      const obj = rows[0][0].originData
      if (this.currentSelect.top?.id === obj?.id) return
      this.currentSelect.top = obj
      this.uploadParams.id = obj?.id

      this.getBottomTable()
      this.getLeftTable()
      this.getRightTable()
      this.getTableLeft({})
    },

    onRowSelectBottom(rows) {
      const obj = rows[0][0].originData
      if (this.currentSelect.bottom?.id === obj?.id) return
      this.currentSelect.bottom = obj
      this.getbottomZbTable()
    },

    async onModifyDataChangeTop(getModifyData, cleanModifyData) {
      const params = { mainId: this.basicInfo.id }
      if (this.currentTab.queryType) {
        params.type = this.currentTab.queryType
      }
      const apiPath =
        this.currentTab.apiCode ||
        this.formatApiPath(this.getTabCode(this.currentTab))
      await addCbFn(
        this.$service,
        `${apiPath}/batch`,
        getModifyData,
        cleanModifyData,
        arr => arr.map(e => ({ ...e, ...params }))
      )
      this.getTableLeft({})
    },

    async onModifyDataChangeBottom(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        `${this.detailConfig.budgetHistoryUrl}/batch`,
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            mainId: this.basicInfo.id,
            itemId: this.currentSelect.top?.id,
            budgetHistoryDataId: e.id
          }))
      )
      await this.getTable({
        type: 'top',
        code: this.getTabCode(this.currentTab),
        isLocal: false
      })
      await this.getBottomTable({ isLocal: false })
    },

    async onModifyDataChangeBottomZb(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        `${this.detailConfig.costIndicatorUrl}/batch`,
        getModifyData,
        cleanModifyData,
        arr => arr.map(e => ({ ...e, mainId: this.basicInfo.id }))
      )
      await this.getTable({
        type: 'top',
        code: this.getTabCode(this.currentTab),
        isLocal: false
      })
      await this.getBottomTable({ isLocal: false })
      await this.getbottomZbTable()
    },

    async uploadAfter() {
      this.getRightTable()
    },

    menusMergeAfterBottom(contextMenuMap) {
      contextMenuMap['插入'] = () => this.handleInsertHistory()
    },

    handleInsertHistory() {
      if (!this.currentSelect.top?.id) {
        return this.$message.warning('请选择一个单项工程')
      }
      this.$refs.HistoryProjectDialog.show({
        mainId: this.basicInfo.id
      })
    },

    handleInsertHistoryConfirm(records) {
      records.forEach(row => {
        row.bhdId = row.id
        row.id = undefined
        row.adjustPriceCoefficient = 1
        if (this.historyInsertType === 'investment') {
          row.costBudgetIndicatorActual = row.totalCostIndicator
        }
      })
      const arr = records.map(row => ({
        ...row,
        costBudget: row.totalCost,
        costBudgetIndicator: row.totalCostIndicator
      }))
      this.$refs.bottomTable.handleInsert(arr)
    },

    async handleGlobalEstimate() {
      this.detailsVm.loadingContainer = true
      const url = `${this.detailConfig.globalEstimateUrl}/${this.basicInfo.id}`
      const hasParams = Object.keys(this.globalEstimateParams).length
      const res = hasParams
        ? await this.$service.post(url, this.globalEstimateParams)
        : await this.$service.post(url)
      this.detailsVm.loadingContainer = false
      if (res?.code === 200) {
        this.$message.success('操作成功')
        this.init()
        this.detailsVm.getBaseInfo(this.basicInfo.id)
      }
    },

    async handleDrEstimate() {
      const options = await this.$service.get(this.detailConfig.drButtonUrl, {
        projectId: this.basicInfo.projectId,
        id: this.basicInfo.id
      })
      this.$selectModal({
        title: '带入估算数据',
        columns: [{ field: 'name', title: '估算名称' }],
        options: options.data || [],
        confirm: async (selectedCellInfos, res) => {
          const row = selectedCellInfos[0][0].originData
          const res2 = await this.$service.post(
            this.detailConfig.drButtonSaveUrl,
            `sourceId=${this.basicInfo.id}&targetId=${row.id}`,
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          )
          if (res2.code === 200) {
            this.$message.success('带入成功')
            this.init()
          }
        }
      })
    },

    handleEditBillBaseAmount(selectedCellInfos) {
      if (selectedCellInfos.length !== 1) {
        return this.$message.warning('只能修改一条数据！')
      }
      this.$refs.SelectBaseAmountDialog.show({
        id: this.basicInfo.id,
        selectedCellInfos: selectedCellInfos
      })
    },

    handleSelectBaseAmountDialogConfirm(selectedCellInfos, str) {
      selectedCellInfos.forEach(cells => {
        const obj = cells[0].originData
        this.$set(obj, 'baseAmount', str)
        this.$refs.topTable.modifyData.set(obj, obj)
      })
    },

    handleCellDblclickRight(args) {
      preViewFile(args.originData?.path)
    },

    initDataHistory(currentTab) {
      this.currentTabHistory = currentTab
      this.getTableLeft({})
    },

    async getTableLeft({ isLocal = true }) {
      this.tableDataLeft = []
      this.tableDataCenter = []
      this.tableDataRight = []
      if (this.isProjectOverviewTab && this.showHistory) {
        const res = await this.$service.get(
          '/business-engineering-classify/list',
          { businessId: this.currentSelect.top?.id }
        )
        this.tableDataLeft = sortRecords(res?.data || [])
        if (res?.data?.length && isLocal && this.$refs.tableLeft) {
          this.$refs.tableLeft.initialized()
        }
      }
    },

    async getTableDataCenter(obj) {
      const res = await this.$service.get(
        '/business-engineering-classify/features',
        { classifyId: obj.id }
      )
      this.tableDataCenter = sortRecords(res?.data || [])
    },

    async getTableDataRight(obj) {
      const res = await this.$service.get(
        '/business-engineering-classify/params',
        { classifyId: obj.id }
      )
      this.tableDataRight = sortRecords(res?.data || [])
    },

    handleRowSelectLeft() {
      const rows = this.$refs.tableLeft.getSelectData()
      const obj = rows[0]?.[0]?.originData
      if (!obj) return
      this.getTableDataCenter(obj)
      this.getTableDataRight(obj)
    },

    async handleModifyDataChangeCenter(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post(
        '/business-engineering-classify/features/batch',
        arr
      )
      if (res?.code === 200) {
        this.$message.success('保存成功')
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        cleanModifyData()
      }
    },

    async handleModifyDataChangeRight(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post(
        '/business-engineering-classify/params/batch',
        arr
      )
      if (res?.code === 200) {
        this.$message.success('保存成功')
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        cleanModifyData()
      }
    },

    async getEngineeringFeatureOptions() {
      const rows = this.$refs.tableCenter.getSelectData()
      const obj = rows[0]?.[0]?.originData
      const res = await this.$service.get(
        '/engineering-classify/feature-values',
        { featureId: obj.sourceId }
      )
      return sortRecords(res?.data || [])
    }
  }
}
</script>

<style scoped lang="less">
.estimate-detail {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;

  ::v-deep .tab-btn .table {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    > div {
      flex: 1;
      height: 33% !important;
    }
  }

  .top-table {
    height: 300px;
  }

  .bottom-table {
    height: 300px;
  }

  .left-right-box1 {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
  }

  .project-overview-box {
    height: 100% !important;
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    > div {
      flex: 1;
    }
  }
}
</style>
